module.exports = __webpack_public_path__ + "static/media/investment_contra.88c76dba.svg";